import { PublishedFormId } from '@furnish-hx/constants/FormId';
import FormTypeId from '@core/constants/FormTypeId';
import fieldPortfolioData from './common/fieldsPortfolioData';
import { IFormFieldKey, IForm } from '../../interfaces/Form';
import fieldsContact from './common/fieldsContact';
import { additionalDataFactory } from './common/fieldsAdditionalData';
import fieldsConnectics from './common/fieldsConnectics';
import fieldsStorages from './common/fieldsStorages';
import { trayDeskShapeDimension } from './common/fieldsTrayShapeDimension';
import {
    fieldsDeskBorder,
    fieldsDeskLegsMaterial,
    fieldsDeskTrayMaterial,
    fieldsDeskLegs,
    fieldsDeskLegsDimension,
} from './common/fieldsDesk';
import budgetMarksBuilder from './common/budgetMarksBuilder';

const deskExecutiveForm: IForm = {
    formId       : PublishedFormId.DeskExecutive,
    type         : FormTypeId.Desk,
    thumbnailURL : '/resized-images/forms/deskExecutive.jpg',
    fieldsOrder  : [
        IFormFieldKey.PortfolioData,
        IFormFieldKey.Comment,
        IFormFieldKey.TrayShapeDimension,
        IFormFieldKey.TrayMaterial,
        IFormFieldKey.Border,
        IFormFieldKey.Connectics,
        IFormFieldKey.AddOns,
        IFormFieldKey.LegsShape,
        IFormFieldKey.LegsMaterial,
        IFormFieldKey.LegsDimension,
        IFormFieldKey.AdditionalData,
        IFormFieldKey.Contact,
    ],
    fields: {
        portfolioData : fieldPortfolioData,
        comment       : {
            comment: {
                value    : undefined,
                required : false,
            },
        },
        trayShapeDimension : trayDeskShapeDimension,
        trayMaterial       : fieldsDeskTrayMaterial,
        border             : fieldsDeskBorder,
        connectics         : fieldsConnectics,
        addOns             : fieldsStorages,
        legsShape          : fieldsDeskLegs,
        legsMaterial       : fieldsDeskLegsMaterial,
        legsDimension      : fieldsDeskLegsDimension,
        additionalData     : additionalDataFactory({
            budgetMin          : 1200,
            budgetMax          : 20000,
            budgetDefaultValue : 5000,
            marks              : budgetMarksBuilder(1200, 100, 8000, 500, 20000),
        }),
        contact: fieldsContact,
    },
};

export default deskExecutiveForm;
